import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Text from 'shopper/components/Text';
import Tooltip from 'shopper/components/Tooltip';

import { formatAsBRLWithSignal } from 'lib/number';

const DIRECTIONS = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
};

const TOOLTIP_DIRECTION_STYLES = {
  [DIRECTIONS.CENTER]: 'left-1/2 -translate-x-1/2',
  [DIRECTIONS.LEFT]: 'right-[unset] left-0',
  [DIRECTIONS.RIGHT]: 'left-[unset] right-0',
};

const ARROW_DIRECTION_STYLES = {
  [DIRECTIONS.CENTER]: 'left-1/2 -translate-x-1/2',
  [DIRECTIONS.LEFT]: 'left-7',
  [DIRECTIONS.RIGHT]: 'right-7',
};

const PriceTooltip = ({ direction, offerPrice }) => (
  <>
    <Tooltip.Root className="w-full">
      <Tooltip.Box
        align={direction}
        autoClose={false}
        className={twJoin(
          'bottom-[-30px] z-1 w-max rounded-4 bg-rd-primary-100 dark:bg-primary-300',
          TOOLTIP_DIRECTION_STYLES[direction]
        )}
        direction="top"
      >
        <Text as="span" className="text-neutral-low-300" size="size3">
          Valor atual
        </Text>
        <Text as="span" className="ml-2 text-neutral-low-300" size="size3" bold>
          {formatAsBRLWithSignal(offerPrice)}
        </Text>
      </Tooltip.Box>
    </Tooltip.Root>
    <div
      className={twJoin(
        'absolute bottom-[52px] size-0 border-[6px] border-b-0 border-t-[12px] border-solid border-transparent border-t-rd-primary-100 dark:border-t-primary-300',
        ARROW_DIRECTION_STYLES[direction]
      )}
    />
  </>
);

PriceTooltip.propTypes = {
  direction: PropTypes.oneOf(Object.values(DIRECTIONS)).isRequired,
  offerPrice: PropTypes.number.isRequired,
};

export default PriceTooltip;
